import type { BootstrapPageViewModel } from '@adapters/presenters/BootstrapPresenter';
import { BootstrapPresenter } from '@adapters/presenters/BootstrapPresenter';
import { GetBootstrapSummaryUseCase } from '@core/usecases/GetBootstrapSummaryUseCase';

export class BootstrapController {
  public constructor(
    private readonly getBootstrapSummaryUseCase: GetBootstrapSummaryUseCase,
    private readonly bootstrapPresenter: BootstrapPresenter
  ) {}

  public async load(): Promise<BootstrapPageViewModel> {
    try {
      const summary = await this.getBootstrapSummaryUseCase.execute();
      return this.bootstrapPresenter.present(summary);
    } catch (error) {
      return this.bootstrapPresenter.presentFailure(error);
    }
  }
}